import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './css/app.css'
import App from './App.tsx'
import 'simple-line-icons/css/simple-line-icons.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
